type PersonLike =
  | {
      firstName?: string;
      preferredName?: string;
      lastName?: string;
    }
  | {
      FirstName?: string;
      PreferredName?: string;
      LastName?: string;
    };

export const getFullName = <T extends PersonLike>(person: T, ignorePreferredName?: boolean): string => {
  const firstName =
    ('firstName' in person ? person.firstName : 'FirstName' in person ? person.FirstName : undefined) ?? '';
  const lastName = ('lastName' in person ? person.lastName : 'LastName' in person ? person.LastName : undefined) ?? '';
  const preferredName =
    (ignorePreferredName
      ? ''
      : 'preferredName' in person
      ? person.preferredName
      : 'PreferredName' in person
      ? person.PreferredName
      : undefined) ?? '';

  return `${preferredName.trim() || firstName.trim() || ''} ${lastName.trim() || ''}`.trim();
};
